export default __webpack_public_path__ + "static/media/user.30793c8c.svg";